$(document).ready(function ($) {

    var editForm = $(".edit-form");
    var editExperience = $(".edit-experience");
    var editEducation = $(".edit-education");
    var editInfoBtn = $(".edit-info");
    var actionUrls = [];
    var currentLanguage = $("#lang").val();
    var langUrl = $("#lang-url").val();

    actionUrls['summary_form'] = '/users/user-edit-profile/edit-summary';
    actionUrls['additional_info_form'] = '/users/user-edit-profile/edit-additional-info';

    editInfoBtn.on("click", function (e) {
        var dataType = $(this).attr("data-type");

        var form = $("#" + dataType);
        var text = $("." + dataType);


        form.removeClass("hide");
        text.addClass("hide");

        // $(this).removeClass("button");
        //$(this).html("<i class='fa fa-pencil'></i>");

        e.preventDefault();
    });


    editForm.on("submit", function (e) {
        var userHeaderCity = editForm.find('.userHeaderCity').val();
        var userHeaderCountry = editForm.find('.userHeaderCountry').val();

        e.preventDefault();

        var formName = $(this).attr("id");
        var field = formName.slice(0, -5);

        var value = $("#" + field).val();
        var text = $("." + $(this).attr("id"));

        text.find("p").text(value);

        $(this).addClass("hide");
        text.removeClass("hide");

        $.ajax({
            type: "POST",
            url: '/users/user-edit-profile/edit-user-field',
            data: {
                value: value,
                field: field,
                lang: currentLanguage,
                userHeaderCity: userHeaderCity,
                userHeaderCountry: userHeaderCountry
            },
            success: success
        });
    });


    editForm.on("reset", function (e) {
        var text = $("." + $(this).attr("id"));

        $(this).addClass("hide");
        text.removeClass("hide");

        e.preventDefault();
    });

    editExperience.on("reset", function (e) {
        var text = $("." + $(this).attr("id"));

        $(this).addClass("hide");
        text.removeClass("hide");

        e.preventDefault();
    });

    editEducation.on("reset", function (e) {
        var text = $("." + $(this).attr("id"));

        $(this).addClass("hide");
        text.removeClass("hide");

        e.preventDefault();
    });

    editExperience.on("submit", function (e) {
        e.preventDefault();

        if (validate($(this)) == false) {
            return;
        }

        var formName = $(this).attr("id");

        var id = $(this).find(".id").val();
        var company_title = $(this).find(".company_title").val();
        var location = $(this).find(".location").val();
        var job_title = $(this).find(".job_title").val();
        var job_achievements = $(this).find(".job_achievements").val();
        var job_responsibilities = $(this).find(".job_responsibilities").val();

        var start_year = $(this).find(".start_year").val();
        var start_month = $(this).find(".start_month").val();
        var end_year = $(this).find(".end_year").val();
        var end_month = $(this).find(".end_month").val();

        var still_working = 0;
        if ($(this).find(".still-working").is(':checked') == true) {
            still_working = 1;
            end_year = null;
            end_month = null;
        }

        var text = $("." + $(this).attr("id"));

        $(".company_title_" + id).text(company_title);
        $(".location_" + id).text(location);
        $(".job_title_" + id).text(job_title);
        $(".job_achievements_" + id).text(job_achievements);
        $(".job_responsibilities_" + id).text(job_responsibilities);

        $(".period_" + id).text(start_year + "-" + end_year);

        $(this).addClass("hide");
        text.removeClass("hide");

        $.ajax({
            type: "POST",
            url: "/" + langUrl + "/users/user-edit-profile/edit-work-experience",
            data: {
                id: id,
                company_title: company_title,
                job_title: job_title,
                location: location,
                job_achievements: job_achievements,
                job_responsibilities: job_responsibilities,
                start_year: start_year,
                start_month: start_month,
                end_year: end_year,
                end_month: end_month,
                still_working: still_working,
                lang: currentLanguage
            },
            success: success
        });

    });

    $("#new_work_experience").on("submit", function (e) {
        e.preventDefault();

        if (validate($(this)) == false)
            return;

        var company_title = $(this).find(".company_title").val();
        var location = $(this).find(".location").val();
        var job_title = $(this).find(".job_title").val();
        var job_achievements = $(this).find(".job_achievements").val();
        var job_responsibilities = $(this).find(".job_responsibilities").val();

        var start_year = $(this).find(".start_year").val();
        var start_month = $(this).find(".start_month").val();
        var end_year = $(this).find(".end_year").val();
        var end_month = $(this).find(".end_month").val();

        var still_working = 0;
        if ($(this).find(".still-working").is(':checked') == true) {
            still_working = 1;
            end_year = null;
            end_month = null;
        }

        $.ajax({
            type: "POST",
            url: '/' + langUrl + '/users/user-edit-profile/add-work-experience',
            data: {
                company_title: company_title,
                job_title: job_title,
                location: location,
                job_achievements: job_achievements,
                job_responsibilities: job_responsibilities,
                start_year: start_year,
                start_month: start_month,
                end_year: end_year,
                end_month: end_month,
                still_working: still_working,
                lang: currentLanguage
            },
            success: success,

        });

        function success() {
            window.location.reload(true);
        }
    });

    $("#new_work_experience").on("reset", function (e) {
        $(this).addClass("hide");
        e.preventDefault();
    });

    $("#new_education").on("reset", function (e) {
        $(this).addClass("hide");
        e.preventDefault();
    });

    editEducation.on("submit", function (e) {
        e.preventDefault();

        if (validate($(this)) == false)
            return;

        var formName = $(this).attr("id");

        var id = $(this).find(".id").val();
        var university_title = $(this).find(".university_title").val();
        var degree = $(this).find(".degree").val();
        var location = $(this).find(".location").val();
        var education_details = $(this).find(".education_details").val();
        var education_achievements = $(this).find(".education_achievements").val();

        var start_year = $(this).find(".start_year").val();
        var start_month = $(this).find(".start_month").val();
        var end_year = $(this).find(".end_year").val();
        var end_month = $(this).find(".end_month").val();

        var still_working = 0;
        if ($(this).find(".still-working").is(':checked') == true) {
            still_working = 1;
            end_year = null;
            end_month = null;
        }

        var text = $("." + $(this).attr("id"));

        $(".university_title_" + id).text(university_title);
        $(".degree_" + id).text(degree);
        $(".location_" + id).text(location);
        $(".education_details_" + id).text(education_details);
        $(".education_achievements_" + id).text(education_achievements);

        $(".period_" + id).text(start_year + "-" + end_year);

        $(this).addClass("hide");
        text.removeClass("hide");

        $.ajax({
            type: "POST",
            url: '/' + langUrl + '/users/user-edit-profile/edit-education',
            data: {
                id: id,
                university_title: university_title,
                degree: degree,
                location: location,
                education_details: education_details,
                education_achievements: education_achievements,
                start_year: start_year,
                start_month: start_month,
                end_year: end_year,
                end_month: end_month,
                still_working: still_working,
                lang: currentLanguage
            },
            success: success,
        });

        function success() {
            window.location.reload(true);
        }

    });

    $('#gender_form').on("submit", function (e) {
        e.preventDefault();
        var genderName = $('input[name="Users[gender_id]"]:checked').closest('label').text();

        $.ajax({
            url: $(this).attr('action'),
            type: 'post',
            data: $(this).serialize(),
            success: function (result) {
                if(result.success) {
                    $('#gender_name').text(genderName);
                    $('#gender_form').addClass('hide');
                    $('.gender_form').removeClass('hide');
                    $('#user_gender_icon').attr('class', result.class);
                }


            }
        });

    });

    $('#gender_form').on("reset",function(){
        $(this).addClass('hide');
        $('.gender_form').removeClass('hide');
    });
    
    $("#new_education").on("submit", function (e) {
        e.preventDefault();

        if (validate($(this)) == false)
            return;

        var university_title = $(this).find(".university_title").val();
        var degree = $(this).find(".degree").val();
        var location = $(this).find(".location").val();
        var education_details = $(this).find(".education_details").val();
        var education_achievements = $(this).find(".education_achievements").val();

        var start_year = $(this).find(".start_year").val();
        var start_month = $(this).find(".start_month").val();
        var end_year = $(this).find(".end_year").val();
        var end_month = $(this).find(".end_month").val();

        var still_working = 0;
        if ($(this).find(".still-working").is(':checked') == true) {
            still_working = 1;
            end_year = null;
            end_month = null;
        }


        $.ajax({
            type: "POST",
            url: '/' + langUrl + '/users/user-edit-profile/add-education',
            data: {
                university_title: university_title,
                degree: degree,
                location: location,
                education_details: education_details,
                education_achievements: education_achievements,
                start_year: start_year,
                start_month: start_month,
                end_year: end_year,
                end_month: end_month,
                still_working: still_working,
            },
            success: success,
        });

        function success() {
            window.location.reload(true);
        }

    });

    $('.item-save-btn').on('click', function () {
        $(this).css("background-color", "#690");
    });

    $(".edit-work").on("click", function (e) {
        var id = $(this).attr("data-id");
        var field = $("#company_title_" + id);
        var selectedItemValue;

        var options = {
            url: "/" + langUrl + "/companies/companies/get-companies-for-ajax",
            getValue: function (element) {
                return element.name;
            },
            list: {
                match: {
                    enabled: true
                },
                onSelectItemEvent: function () {
                    selectedItemValue = field.getSelectedItemData();
                },
                onHideListEvent: function () {
                    //console.log(selectedItemValue);
                }
            },
            theme: "square"
        };

        field.easyAutocomplete(options);
    });


    $(".add_new_work_experience_btn").on("click", function (e) {
        $("#new_work_experience").removeClass("hide");
        $('html, body').animate({
            scrollTop: $("#new_work_experience").offset().top
        }, 500);
        var id = $(this).attr("data-id");
        var field = $("#company_title");
        var selectedItemValue;

        var options = {
            url: "/" + langUrl + "/companies/companies/get-companies-for-ajax",
            getValue: function (element) {
                console.log(element);
                return element.name;
            },
            list: {
                match: {
                    enabled: true
                },
                onSelectItemEvent: function () {
                    selectedItemValue = field.getSelectedItemData();
                },
                onHideListEvent: function () {
                    //console.log(selectedItemValue);
                }
            },
            theme: "square"
        };

        field.easyAutocomplete(options);

        e.preventDefault();
    });


    $(".add_new_education_btn").on("click", function (e) {
        $("#new_education").removeClass("hide");
        $('html, body').animate({
            scrollTop: $("#new_education").offset().top
        }, 500);

        e.preventDefault();
    });

    /*hard skills*/
    $(".btn-hard-skills").on("click", function (e) {
        e.preventDefault();

        $(".hard-skills-list").addClass("hide");
        $("#hard-skills").removeClass("hide");
    });

    $("#hard-skills-cancel-btn").on("click", function (e) {
        e.preventDefault();

        $(".hard-skills-list").removeClass("hide");
        $("#hard-skills").addClass("hide");
    });
    /* hard skills*/

    /* soft skills*/
    $(".btn-soft-skills").on("click", function (e) {
        e.preventDefault();

        $(".soft-skills-list").addClass("hide");
        $("#soft-skills").removeClass("hide");
    });

    $("#soft-skills-cancel-btn").on("click", function (e) {
        e.preventDefault();

        $(".soft-skills-list").removeClass("hide");
        $("#soft-skills").addClass("hide");
    });
    /* soft skills*/

    /* languages*/
    $(".btn-languages").on("click", function (e) {
        e.preventDefault();

        $(".languages-list").addClass("hide");
        $("#languages").removeClass("hide");
    });

    $("#languages-cancel-btn").on("click", function (e) {
        e.preventDefault();

        $(".languages-list").removeClass("hide");
        $("#languages").addClass("hide");
    });
    /* languages*/


    $(document).on("click", ".still-working", function (e) {
        // var target = "#" + $(this).attr("id").slice(1,0);
        var target = "#" + $(this).attr("id").slice(1, $(this).attr("id").length);


        if ($(this).is(':checked')) {
            $(target).addClass("hide");

            $(target).find(".end_month").removeClass("required-field");
            $(target).find(".end_year").removeClass("required-field");
        } else {
            $(target).removeClass("hide");

            $(target).find(".end_month").addClass("required-field");
            $(target).find(".end_year").addClass("required-field");
        }
    });

    function validate(obj) {
        var _isValid = true;
        var fiealds = obj.find(".required-field");

        fiealds.each(function (i) {
            if (!$(this).val()) {
                $(this).parent(".form-group").addClass("has-error");
                $(this).parent("div").addClass("has-error");
                _isValid = false;
            }
        })

        return _isValid;
    }

    function isFormValid(obj){
        console.log(obj);
        var _isValid = true;
        var fiealds = obj.find(".required").find("input");
        console.log(fiealds);
        fiealds.each(function (i) {
            if (!$(this).val()) {
                _isValid = false;
            }
        });

        return _isValid;
    }

    function required_together(obj) {
        var _isValid = false;
        var fiealds = obj.find(".required-together");

        fiealds.each(function (i) {
            if ($(this).val()) {
                _isValid = true;
                return false;
            }
        });
        if (!_isValid) {
            $(".required-together").parent().addClass("has-error").removeClass('has-success');
            $('.required_together_error').removeClass('hidden');
        }
        else {
            $(".required-together").parent().addClass("has-success").removeClass('has-error');
            $('.required_together_error').addClass('hidden');
        }

        return _isValid;
    }

    function reset_validation(obj){
        $('.required_together_error').addClass('hidden');
        $(obj).find('.form-group').removeClass('has-success has-error')
    }

    var body = $('body');

    body.on('change keyup', ".required-together", function (e) {
        var reference_email_input = $("#referenceform-email.required-together");
        if ($(this).val()) {
            $(".required-together").parent().addClass("has-success").removeClass('has-error');
            $('.required_together_error').addClass('hidden');
            if(reference_email_input.next('.help-block').text()) {
                reference_email_input.parent().addClass("has-error").removeClass('has-success');
            }
        } else {
            var _isValid = false;
            var fiealds = $(".required-together").not(this);
            fiealds.each(function (i, val) {
                if ($(val).val()) {
                    _isValid = true;
                    return false;
                }
            });
            if (!_isValid) {
                $(".required-together").parent().addClass("has-error").removeClass('has-success');
                $('.required_together_error').removeClass('hidden');
            }
            else {
                $(".required-together").parent().addClass("has-success").removeClass('has-error');
                $('.required_together_error').addClass('hidden');
                if(reference_email_input.next('.help-block').text()) {
                    reference_email_input.parent().addClass("has-error").removeClass('has-success');
                }
            }
        }
    });


    $(".required-field").on("change", function (e) {
        if (!$(this).val()) {
            $(this).parent().addClass("has-error");
        } else {
            $(this).parent().removeClass("has-error");
        }
    });


    function success() {
        window.location.reload(true);
    }

    body.on('click', '#save_new_hard_skill', function(){
        var skill_type = $(this).data('skill_type');
        var form = $('#new_hard_skill_form');
        var url = $(this).data('request_new_skill_url');  
        var mainForm = $('.hard_skills_save_form');
        if(required_together(form)) {
            if(isFormValid(mainForm)) {

                form.find('.form_button_block').find('button').attr('disabled', true);
                $(this).append('<i class="ml5 fa fa-spinner fa-spin"></i>');
                form.addClass('frozen');
                var knowledge_level_id = $('input[name="knowledge_level_id"]').val();
                var skill_titles = {};
                $('.new_hard_skill_title').each(function(key, value){
                    var lang_url = $(value).data('lang_url');
                    skill_titles[lang_url] = $(value).val();
                });
                $.ajax({
                    type: "POST",
                    url: url,
                    data: {
                        type: skill_type,
                        knowledge_level_id: knowledge_level_id,
                        skill_titles: skill_titles
                    },
                    success: function(data){
                        mainForm.submit();
                        var type = 'error';
                        if(data.success){
                            type = "success";
                            $('#new-hard-skills').find('input').val('');
                            reset_validation(form);
                            $('[data-toggle="popover"]').popover();
                        }
                        $('#user_info_update_modal').modal('hide');
                    }
                })
            }
            else {
                $('button.cancel.change_skills_modal_view').trigger('click');
            }

        }
    });

    body.on('click', '#save_new_soft_skill', function(){
        var skill_type = $(this).data('skill_type');
        var form = $('#new_soft_skill_form');
        var url = $(this).data('request_new_skill_url');        
        if(required_together(form)) {
            form.find('.form_button_block').find('button').attr('disabled', true);
            $(this).append('<i class="ml5 fa fa-spinner fa-spin"></i>');
            form.addClass('frozen');
            var skill_titles = {};
            $('.new_soft_skill_title').each(function(key, value){
                var lang_url = $(value).data('lang_url');
                skill_titles[lang_url] = $(value).val();
            });
            $.ajax({
                type: "POST",
                url: url,
                data: {
                    type: skill_type,
                    skill_titles: skill_titles
                },
                success: function(data){
                    $('#soft-skills-form').submit();
                    var type = 'error';
                    if(data.success){
                        type = "success";
                        $('#new-soft-skills').find('input').val('');
                        reset_validation(form);
                        var template = _.template($(form.data('tpl')).html());
                        if (data.requestedSkills.length) {
                            $(form.data('new_block')).html(template({data: data.requestedSkills, type: 'new_skill'}));
                        }
                        $('[data-toggle="popover"]').popover();
                    }
                    $('#user_info_update_modal').modal('hide');
                    // showNotification(data.message, type);
                }
            })
        }
    });
    
    body.on('click', '.remove-new-soft-skill', function(){
        $(this).parents('.skills-delete-container').addClass('hidden removed');
        var requested_soft_skills_length = $('#new_soft_skills_container').find('.skills-delete-container').not('.removed').length;
        initSelect2('#softskillsform-skills', 10-requested_soft_skills_length, $('#softskillsform-skills').attr('errormsg'));
        $('#request_new_soft_skill_text').removeClass('hidden');

    });

    body.on('click', '.remove-new-hard-skill', function(){
         $(this).parents('.requested_hard_skills').addClass('hidden removed').removeClass('visible').find('.knowledge_level_bar').remove();
         $('.skills_limit_text_container').remove();
         $('#add_hard_skill').attr('disabled', false);
         $('#request_new_skill_text').removeClass('hidden');
    });

    body.on('change', '#softskillsform-skills', function(){
        var selected_soft_skills_length = $(this).val() ? $(this).val().length : 0;
        var requested_soft_skills_length = $('#new_soft_skills_container').find('.skills-delete-container').not('.removed').length;
        var sum_soft_skills_length = selected_soft_skills_length + requested_soft_skills_length;
        if(sum_soft_skills_length == 10){
            $('#request_new_soft_skill_text').addClass('hidden');
        }
        else {
            $('#request_new_soft_skill_text').removeClass('hidden');
        }
    });
    
    var new_added_skills_count, existing_skills_is_changed;
    $(document).on('click', '.btn_add_block_info, .btn_edit_block_info, .btn_child_edit', function () {
        new_added_skills_count = 0;
        existing_skills_is_changed = false;
    });

    body.on('click', '#add_hard_skill', function(){
        new_added_skills_count++;
    });

    body.on('click', '.remove-skill', function(){
        if($(this).data('id')){
            existing_skills_is_changed = true;
        }
        else {
            new_added_skills_count--;
        }
    });

    body.on('click', '.change_skills_modal_view', function(e){
        e.preventDefault();
        var block = $(this).data('block');
        $(block).removeClass('hidden');
        $(this).parents('.skills_block').addClass('hidden');
    });

    function arraysEqual(arr1, arr2) {
        if(arr1.length !== arr2.length)
            return false;
        for(var i = arr1.length; i--;) {
            if(arr1[i] !== arr2[i])
                return false;
        }

        return true;
    }

    $('[data-toggle="popover"]').popover();

    body.on('click', '#btn_submit_form_reference', function(){
        var form = $('#reference-form');
        required_together(form);
    });

    body.on('change', '#employmentform-end_month', function(){
        $('#employment-form').yiiActiveForm('validateAttribute', 'employmentform-end_year');
    });
    body.on('change', '#employmentform-end_year', function(){
        $('#employment-form').yiiActiveForm('validateAttribute', 'employmentform-end_month');
    });

    body.on('change', '#educationform-end_month', e => {
        $('#education-form').yiiActiveForm('validateAttribute', 'educationform-end_year');
    });
    body.on('change', '#educationform-end_year', e => {
        $('#education-form').yiiActiveForm('validateAttribute', 'educationform-end_month');
    });

    body.on('click', '.my_jobs_tabs_titles .switch_user_search', function(){
        $('.my_jobs_tabs_titles .switch_user_search').removeClass('active');
        $(this).addClass('active');
        $('#my_jobs_trainings_section .my_job_block').addClass('hidden');
        $('#my_jobs_trainings_section').find($(this).data('container_id')).removeClass('hidden');

    });
    body.on('click', '.matching_trainings_tab .saved_jobs_tab', function(){
        $('#matching_jobs_container1').addClass('hidden');
    });
    body.on('click', '.based_on_sunscriptions', function(){
        $('#matching_jobs_container1').removeClass('hidden');
        $('#matching_jobs_container').removeClass('hidden');
        $('#ai_jobs_container').addClass('hidden');
        $('#ai_jobs_container').addClass('hidden');
    });
    body.on('click', '.based_on_cv', function(){
        $('#matching_jobs_container').addClass('hidden');
        $('#ai_jobs_container').removeClass('hidden');
    });
    body.on('click', '.matching_jobs_nav_tabs', function(){
        $('.matching_jobs_nav_tabs').removeClass('active');
        $(this).addClass('active');
    });
});

